import { MoreVert } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { useState } from 'react';
import { colorTheme } from '@styles/muiTheme';
import { HistoryButtonPopOver } from './HistoryBtnPopOver';
import { HistoryMenu } from './HistoryMenu';

export const HistoryButton = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [hoverAnchorEl, setHoverAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const openHover = Boolean(hoverAnchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setHoverAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setHoverAnchorEl(null);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <IconButton
        aria-label="Recently Closed Tabs"
        aria-controls={open ? 'recently-closed-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        sx={{ color: colorTheme.palette.common.black }}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        onClick={handleMenuClick}
      >
        <MoreVert />
      </IconButton>

      <HistoryButtonPopOver
        openHover={openHover}
        hoverAnchorEl={hoverAnchorEl}
        handlePopoverClose={handlePopoverClose}
      />

      <HistoryMenu
        open={open}
        anchorEl={anchorEl}
        handleMenuClose={handleMenuClose}
      />
    </Box>
  );
};
